import React from 'react';
import { generatePath, Switch, Route, Redirect } from 'react-router-dom';
import routes from '@achievable-me/tundra-wizard/routes';
import SpinnerError from '$components/library/SpinnerError';
import { gql } from '@apollo/client';
import { useQuery } from '@apollo/react-hooks';
import EnrollLayout from './EnrollLayout';
import Overview from './Overivew';
import Purchase from './Purchase';

const ENROLLING_ORGANIZATION = gql`
  query EnrollingOrganization($input: EnrollingOrganizationInput!) {
    enrollingOrganization(input: $input) {
      organization {
        logoHref
        name
        slug
        tagline
        uuid
        pricingOverrides {
          uuid
          productUuid
          price
        }
      }
    }
  }
`;

const Enroll = (props) => {
  const { code, currentUser } = props;

  const { data, loading, error } = useQuery(ENROLLING_ORGANIZATION, {
    variables: { input: { organizationSlug: code } },
  });

  if (loading || error) {
    return <SpinnerError error={error} />;
  }

  const {
    enrollingOrganization: { organization },
  } = data;

  if (!organization) {
    return (
      <div>
        URL not found, please email support@achievable.me or call/text 415-831-7733
      </div>
    );
  }

  return (
    <EnrollLayout organization={organization}>
      <Switch>
        <Route path={routes.enroll.overview}>
          <Overview organization={organization} currentUser={currentUser} />
        </Route>
        <Route path={routes.enroll.purchase}>
          <Purchase organization={organization} currentUser={currentUser} />
        </Route>
        <Route>
          <Redirect to={generatePath(routes.enroll.purchase, { code })} />
        </Route>
      </Switch>
    </EnrollLayout>
  );
};

export default Enroll;
